export default __webpack_public_path__ + "static/media/d17.fe708c3f.png";